import { memo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useSelectedOrganization } from "../../../organizations/hooks";
import { useGroupDetails } from "../../hooks/useGroupDetails";
import { GroupDetailsView } from "../components";
import type { Permissions } from "../../../gql-generated/aliases";

export const GroupDetailsContainerV2 = memo(function GroupDetailsContainerV2() {
    const { selectedOrganizationId, permissions } = useSelectedOrganization();
    const { orgId } = useParams();
    const organizationId = orgId ?? selectedOrganizationId ?? "";
    const {
        groupDetails,
        loading,
        error,
        saving,
        saveChanges,
        addLensesToGroup,
        removeLensFromGroup,
        updateFilter,
        updateLensInGroup,
        updateName,
        updateDescription,
    } = useGroupDetails();

    const navigate = useNavigate();

    const goToGroupsTab = useCallback(() => {
        navigate("..", { relative: "path" });
    }, [navigate]);

    return (
        <GroupDetailsView
            isError={!!error}
            group={groupDetails}
            loading={loading}
            saving={saving}
            readonly={groupDetails?.info.isArchived || groupDetails?.info.readOnly}
            organizationId={organizationId}
            onSaveChanges={saveChanges}
            onAddLenses={addLensesToGroup}
            onRemoveLens={removeLensFromGroup}
            onSearch={updateFilter}
            onLensInGroupChanged={updateLensInGroup}
            onLensGroupSuccessfullyDeleted={goToGroupsTab}
            onNameChanged={updateName}
            onDescriptionChanged={updateDescription}
            permissions={permissions ?? ({} as Permissions)}
        />
    );
});
